import React,{useState} from "react";
import { Button, Modal,Row,Col,Form } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import axios from "../axios/axios";
// import BodyTextEditor from "./BodyTextEditor";
import { message } from "antd";
import LoadingOverlay from "react-loading-overlay";
import { useSelector,useDispatch } from "react-redux";
import { setEscapeBuckRedeemModal, setApiCallForFetchingEscapeBuckAmount,setApiCallForFetchingEscapeRedeemHistory } from "../actions/escapeBucks.actions";

const RedeemEscapeBuckCodeModal = () => {
    const dispatch = useDispatch();
    const modalShow = useSelector((state) => state.escapeBucksRedux.escapeBuckCodeRedeemModal);
    const [loading, setLoading] = useState(false);
  const history = useHistory();
     const [careFiCode, setCareFiCode] = useState("");
     const handelModalClose = () => {
        dispatch(setEscapeBuckRedeemModal(false));
     }
      const handelChange = (e) => {
          setCareFiCode(e.target.value);
  
      }
          const submitCode = async () => {
              if (!careFiCode) {
                  message.error("Please enter code");
                  return;
              }
               setLoading(true);
              const config = {
                  headers: {
                      Authorization: `Bearer ${localStorage.getItem("AuthToken")}`,
                  },
              };
              await axios
                  .post(`/user/redeem-vip-code`, { code: careFiCode }, config)
                  .then((res) => {
                      if (res.data.status) {
                          message.success(res.data.message);
                          setCareFiCode("");
                          dispatch(setApiCallForFetchingEscapeBuckAmount(true));
                          dispatch(setApiCallForFetchingEscapeRedeemHistory(true));
                          dispatch(setEscapeBuckRedeemModal(false));
                          setLoading(false);
                      } else {
                           setLoading(false);
                          message.error(res.data.message);
                      }
                  })
                  .catch((err) => {
                       setLoading(false);
                      console.log("err", err);
                      message.error("Something went wrong. Please try again");
                  });
          }
  return (
    <>
      <Modal show={modalShow} onHide={handelModalClose}>
        <Modal.Body>
          <div className="modal_close">
            <h3>Escape Credits Code Redemption</h3>
            <Button
              variant="secondary"
              onClick={handelModalClose}
              className="close_buuut"
            ></Button>
          </div>
         <LoadingOverlay active={loading} spinner text="Loading ...">
          <Row className="mt-4">
                           
                            <Col md={12}>
                                <Form className="mt-3">
                                    <Row>
                                        <Col lg="12" md="6" sm="12">
                                            <Form.Group className="" controlId="formBasicEmail">

                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter Redemption Code"
                                                    name="first"
                                                    className=""
                                                    value={careFiCode}
                                                    onChange={handelChange}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col lg="12" md="6" sm="12" className="text-center">
                                            <Form.Group className="mt-3" controlId="formBasicEmail">
                                                <Button
                                                    variant="primary"
                                                    type="button"
                                                    className="sub_but"
                                                    onClick={submitCode}
                                                >
                                                    Submit
                                                </Button>
                                            </Form.Group>
                                        </Col>
                                    </Row>


                                </Form>
                            </Col>
                        </Row>
                        </LoadingOverlay>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default RedeemEscapeBuckCodeModal;
